export default __webpack_public_path__ + "static/media/ro4.132b3d48.jpg";